export default {"src":"/_next/static/media/check-violet.e64caf5b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};